<i class="block-icon" [ngClass]="icon" *ngIf="icon"></i>

<ng-content></ng-content>

<span *ngIf="withArrow" class="arrow">
	{{ !isActive ? '▼' : '▲'}}
</span>
